import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import TableComponent from '../../TableComponent';
import Alert from '../../Alert';
import Paginator from '../../Paginator';
import Chat from './chat';
import CircularProgress from '@mui/material/CircularProgress';
import SectionTitle from '../../SectionTitle';

// Queries
import getMisAtenciones from '../../Queries/getMisAtenciones';

// Styles
import styles from './index.module.sass';

export default function History({ device, webservice, getCookie, setSessionMessage }) {
  const { screenSize = '' } = device;
  const { t } = useTranslation('attentions');
  const [attentionsData, setAttentionsData] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertText, setAlertText] = useState('');
  const [totPages, setTotPages] = useState(0);
  const [actualPage, setActualPage] = useState(1);
  const [actualData, setActualData] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);
  const [rowSelected, setRowSelected] = useState('');
  const [thisCount, setThisCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const attentionslHeader = t('attentionslHeader', { returnObjects: true });

  const attentionsToView = 30;

  function handlePage(e) {
    const value = e.target.value;
    setActualPage(parseInt(value));
  }

  function openChat(key) {
    setRowSelected(actualData[key]);
    setChatOpen(true);
  }

  useEffect(() => {
    const sec = t('sections', { returnObjects: true });
    if (thisCount > 0) {
      const pages = Math.ceil(thisCount / attentionsToView);
      const initialPage = (actualPage - 1) * attentionsToView;
      let tempArray = [];
      for (let i = 0; i < attentionsToView; i++) {
        if (attentionsData[i + initialPage]) {
          tempArray[i + initialPage] = attentionsData[i + initialPage];
          for (let h = 0; h < sec.length; h++) {
            if (sec[h].value === parseInt(tempArray[i + initialPage].area)) {
              tempArray[i + initialPage].areaDescri = sec[h].section;
            }
          }
        }
      }
      setActualData(tempArray);
      setTotPages(pages);
    }
  }, [attentionsData, thisCount, t, actualPage]);

  const getMyAtt = useCallback(async () => {
    setLoading(true);
    const order = 'desc';
    const orderby = 'folio';

    const jsonBody = {
      orderby,
      order,
    };

    const response = await getMisAtenciones({ jsonBody });

    const { atenciones = [], count = '0', tipoMensaje = 'error', mensaje = '' } = response;

    setSessionMessage(mensaje);

    setAttentionsData(atenciones);
    setThisCount(parseInt(count));
    if (tipoMensaje !== 'exito' && mensaje !== '498' && mensaje !== '499') {
      setAlertTitle('Ooops!');
      setAlertText(mensaje);
      setOpen(true);
    }
    setLoading(false);
  }, [setSessionMessage]);

  useEffect(() => {
    getMyAtt();
  }, [getMyAtt]);

  return (
    <div id={styles.History} className={`${styles[screenSize]} ${styles.attentions}`}>
      <Alert open={open} setOpen={setOpen} title={alertTitle} text={alertText} />
      <Chat
        open={chatOpen}
        setOpen={setChatOpen}
        rowSelected={rowSelected}
        getCookie={getCookie}
        webservice={webservice}
        setSessionMessage={setSessionMessage}
      />
      <SectionTitle title={t('attentions')} subtitle='' />
      <div className={styles.tableContainer}>
        <div className={styles.historyTitle}>{t('historyTitle')}</div>
        {(loading && <CircularProgress className={styles.LoadingHistory} />) || (
          <>
            <TableComponent
              screenSize={screenSize}
              tableData={actualData}
              tableItems={attentionslHeader}
              rowCallback={openChat}
            />
            <div className={styles.paginator}>
              <div className={styles.paginator2}>&nbsp;de {totPages}</div>
              {totPages > 0 && (
                <Paginator callback={handlePage} actualPage={actualPage} totPages={totPages} />
              )}
              <label className={styles.paginator2}>
                <div>{t('page')}: &nbsp;</div>
              </label>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
